var _g, _ellipse, _ellipse2, _path, _ellipse3, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMcp = function SvgMcp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 46,
    height: 44,
    fill: "none",
    viewBox: "0 0 46 44"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#mcp_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.429,
    d: "M41.952 20.714H3.381"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    width: 26.562,
    height: 43.706,
    x: 18.671,
    y: 0.039
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(.95px)",
      clipPath: "url(#mcp_svg__b)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 1.892,
    filter: "url(#mcp_svg__c)"
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.952,
    cy: 20,
    fill: "url(#mcp_svg__d)",
    rx: 5.714,
    ry: 14.286
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeOpacity: 0.15,
    strokeWidth: 0.714,
    d: "M31.952 6.072c.659 0 1.323.332 1.965 1.01.642.68 1.237 1.681 1.744 2.949 1.013 2.533 1.648 6.058 1.648 9.97 0 3.91-.635 7.435-1.648 9.968-.507 1.268-1.102 2.27-1.744 2.948-.642.679-1.306 1.011-1.965 1.011-.66 0-1.323-.332-1.964-1.01-.642-.68-1.238-1.681-1.745-2.949-1.013-2.533-1.647-6.058-1.647-9.969s.634-7.436 1.647-9.97c.507-1.267 1.103-2.268 1.745-2.947.641-.679 1.305-1.011 1.964-1.011Z",
    style: {
      mixBlendMode: "soft-light"
    }
  })), /*#__PURE__*/React.createElement("foreignObject", {
    width: 26.562,
    height: 43.706,
    x: 9.385,
    y: 0.039
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(.95px)",
      clipPath: "url(#mcp_svg__e)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 1.892,
    filter: "url(#mcp_svg__f)",
    shapeRendering: "crispEdges"
  }, _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.666,
    cy: 20,
    fill: "url(#mcp_svg__g)",
    fillOpacity: 0.5,
    rx: 5.714,
    ry: 14.286
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.666,
    cy: 20,
    fill: "url(#mcp_svg__h)",
    fillOpacity: 0.25,
    rx: 5.714,
    ry: 14.286,
    style: {
      mixBlendMode: "screen"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeOpacity: 0.1,
    strokeWidth: 0.714,
    d: "M22.666 6.072c.66 0 1.323.332 1.965 1.01.642.68 1.237 1.681 1.744 2.949 1.013 2.533 1.648 6.058 1.648 9.97 0 3.91-.635 7.435-1.648 9.968-.507 1.268-1.102 2.27-1.744 2.948-.642.679-1.306 1.011-1.965 1.011s-1.322-.332-1.964-1.01c-.642-.68-1.238-1.681-1.745-2.949-1.013-2.533-1.647-6.058-1.647-9.969s.634-7.436 1.647-9.97c.507-1.267 1.103-2.268 1.745-2.947.641-.679 1.305-1.011 1.964-1.011Z"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    width: 26.562,
    height: 43.706,
    x: 0.1,
    y: 0.039
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(.95px)",
      clipPath: "url(#mcp_svg__i)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 1.892,
    filter: "url(#mcp_svg__j)",
    shapeRendering: "crispEdges"
  }, _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.381,
    cy: 20,
    fill: "url(#mcp_svg__k)",
    fillOpacity: 0.2,
    rx: 5.714,
    ry: 14.286
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.381,
    cy: 20,
    fill: "url(#mcp_svg__l)",
    rx: 5.714,
    ry: 14.286,
    style: {
      mixBlendMode: "screen"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeOpacity: 0.5,
    strokeWidth: 0.714,
    d: "M13.38 6.072c.66 0 1.324.332 1.965 1.01.642.68 1.237 1.681 1.744 2.949 1.014 2.533 1.649 6.058 1.649 9.97 0 3.91-.635 7.435-1.649 9.968-.507 1.268-1.102 2.27-1.744 2.948-.641.679-1.306 1.011-1.965 1.011s-1.322-.332-1.964-1.01c-.642-.68-1.238-1.681-1.745-2.949C8.658 27.436 8.024 23.911 8.024 20s.634-7.436 1.647-9.97c.507-1.267 1.103-2.268 1.745-2.947s1.305-1.011 1.964-1.011Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "mcp_svg__a",
    width: 41.429,
    height: 2.857,
    x: 1.952,
    y: 20,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.179
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.089
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.980392 0 0 0 0 0.505882 0 0 0 0 0.396078 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4384_4763"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.714
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.357
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.929412 0 0 0 0 0.380392 0 0 0 0 0.431373 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_4384_4763",
    result: "effect2_dropShadow_4384_4763"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_4384_4763",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "mcp_svg__c",
    width: 26.562,
    height: 43.706,
    x: 18.671,
    y: 0.039,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.892
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.783
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.690196 0 0 0 0 0.698039 0 0 0 0 0.729412 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "multiply",
    result: "effect1_dropShadow_4384_4763"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4384_4763",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "mcp_svg__f",
    width: 26.562,
    height: 43.706,
    x: 9.385,
    y: 0.039,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.892
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.783
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.690196 0 0 0 0 0.698039 0 0 0 0 0.729412 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "multiply",
    result: "effect1_dropShadow_4384_4763"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4384_4763",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "mcp_svg__j",
    width: 26.562,
    height: 43.706,
    x: 0.1,
    y: 0.039,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.892
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.783
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.690196 0 0 0 0 0.698039 0 0 0 0 0.729412 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "multiply",
    result: "effect1_dropShadow_4384_4763"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4384_4763",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mcp_svg__d",
    x1: 32.325,
    x2: 32.325,
    y1: 6.096,
    y2: 49.164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D92E7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mcp_svg__g",
    x1: 22.666,
    x2: 22.666,
    y1: 18.393,
    y2: 34.286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9A6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#E95971"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mcp_svg__k",
    x1: 13.381,
    x2: 13.381,
    y1: 18.393,
    y2: 34.286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#F3F3F3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "mcp_svg__b",
    transform: "translate(-18.671 -.04)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.952,
    cy: 20,
    rx: 5.714,
    ry: 14.286
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "mcp_svg__e",
    transform: "translate(-9.385 -.04)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.666,
    cy: 20,
    rx: 5.714,
    ry: 14.286
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "mcp_svg__i",
    transform: "translate(-.1 -.04)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.381,
    cy: 20,
    rx: 5.714,
    ry: 14.286
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "mcp_svg__h",
    width: 4,
    height: 1.6,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#mcp_svg__m",
    transform: "scale(.0039 .00156)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "mcp_svg__l",
    width: 4,
    height: 1.6,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#mcp_svg__m",
    transform: "scale(.0039 .00156)"
  })))));
};
export default SvgMcp;